import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function convertScoreToFive(score: number | null | undefined) {
  if (score === null || score === undefined || Number.isNaN(score)) {
    return "-"
  }

  const normalized = Math.min(Math.max(score, 0), 100)
  const fiveScaleScore = (normalized / 100) * 5

  return (Math.round(fiveScaleScore * 100) / 100).toFixed(2)
}
